/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Defaults_TitleInputs */



/**
* | output |
* | --- |
* | "Defaults for new agents" |
*
* @param {Agent_Policy_Defaults_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_defaults_title = /** @type {((inputs?: Agent_Policy_Defaults_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Defaults_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardwerte für neue Agenten")
	return /** @type {LocalizedString} */ ("Defaults for new agents")
});